import { createFileRoute } from '@tanstack/react-router';
import { PlanUsagePage } from '@/pages/plan-usage/ui/PlanUsagePage';

/**
 * プラン＆使用量ルート
 */
export const Route = createFileRoute('/_protected/plan-usage')({
  component: PlanUsagePage,
});
